/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {listEmailQuicktexts} from '../api'

export const useMutationListEmailQuicktexts = createReactQueryMutationHook('listEmailQuicktexts', listEmailQuicktexts)
